<template>
  <div class="school-system-permissions">
    <el-form :inline="true" class="form-style" size="small">
      <el-form-item label="所属科目">
        <el-select v-model="ruleForm.subject_id" placeholder="请选择科目" style="width: 150px" :loading="loading" @change="search" clearable>
          <el-option :label="item.subjectInfo.name" :value="item.subjectInfo.id" v-for="(item, index) of subjectList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="到期状态">
        <el-select v-model="off_time_state" placeholder="请选择" @change="search" style="width: 150px">
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-button size="mini" type="primary" @click="addSubjectPermission" icon="el-icon-plus">添加课程权限</el-button>

      <el-button size="mini" @click="bulkUpdate" icon="el-icon-edit">批量修改时间</el-button>

      <el-button plain type="danger" size="mini" @click="bulkDelete" icon="el-icon-delete">批量删除</el-button>

      <el-button style="float: right" size="mini" round type="info" @click="AddData">继续添加校区资源<i class="el-icon-d-arrow-right el-icon--right"></i></el-button>
    </el-form>
    <div class="table-style">
      <el-table size="mini" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange1">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column align="center" width="50" label="序号">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + pageSize * (page_no - 1) }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="educational_institution_name" label="校区名称"></el-table-column>
        <el-table-column prop="subject_name" label="科目名称"></el-table-column>

        <el-table-column prop="curriculum_name" label="课程名称"></el-table-column>

        <!-- <el-table-column  prop="created_time" label="录入时间"></el-table-column> -->
        <el-table-column prop="off_time" label="截止日期"></el-table-column>
        <el-table-column prop="is_try" label="发布类型">
          <template slot-scope="scope">
            <span v-if="scope.row.is_try === false">合作校区</span>
            <span v-if="scope.row.is_try === true">体验校区</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="updateSubjectPermission(scope.row)">编辑</el-button>
            <el-button type="text" @click="deleteSubjectPermission(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <!-- <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" :page-size="pageSize"
        layout="total, prev, pager, next" :total="total"></el-pagination> -->
      <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange" :current-page="page_no" :page-size="pageSize" :total="total" :page-sizes="[10, 15, 20, 30, 40, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>

    <el-dialog title="新增课程权限" :visible.sync="dialogVisible" width="80%">
      <el-form ref="form" :model="form" label-position="left" size="mini" :inline="true">
        <el-form-item label="所属科目">
          <el-select v-model="form.subject_id" placeholder="请选择科目" @change="getCurriculumList('change')" style="width: 120px">
            <el-option :label="item.subjectInfo.name" :value="item.subjectInfo.id" v-for="(item, index) of subjectList" :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="课程类别">
          <el-select v-model="form.curriculum_type" style="width: 100px" @change="getCurriculumList('change')" clearable>
            <el-option label="体验课" :value="1"></el-option>
            <el-option label="常规课" :value="2"></el-option>
            <el-option label="短期课" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布类型">
          <el-select v-model="form.is_try" style="width: 100px" @change="getCurriculumList('change')">
            <el-option label="全部" value=""></el-option>
            <el-option label="体验校区" value="1"></el-option>
            <el-option label="合作校区" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有效">
          <el-select v-model="form.is_effective" style="width: 100px" @change="getCurriculumList('change')">
            <el-option label="全部" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-divider direction="vertical"></el-divider>
        </el-form-item>

        <el-form-item style="float: right" label="截止日期:" required>
          <el-date-picker v-model="form.off_time" default-time="23:59:59" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择系统截止日期">
          </el-date-picker>
        </el-form-item>
      </el-form>

      <el-table size="mini" :data="curriculum_list" :header-cell-style="{ background: '#f5f7fa' }" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" height="400px">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column align="center" width="50" label="序号">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + 20 * (page_no - 1) }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="授课类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.teaching_type == '1'">面授课</span>
            <span v-else-if="scope.row.teaching_type == '2'">直播课</span>
            <span v-else-if="scope.row.teaching_type == '3'">录播课</span>
          </template>
        </el-table-column>

        <el-table-column width="100" align="center" label="课程类别">
          <template slot-scope="scope">
            <span v-if="scope.row.curriculum_type == '1'">体验课</span>
            <span v-else-if="scope.row.curriculum_type == '2'">常规课</span>
            <span v-else-if="scope.row.curriculum_type == '3'">短期课</span>
          </template>
        </el-table-column>

        <el-table-column width="100" prop="id" label="课程封面" align="center">
          <template slot-scope="scope">
            <el-image style="width: 32.5px; height: 15px" :src="scope.row.img_url" fit="cover"></el-image>
          </template>
        </el-table-column>

        <el-table-column prop="subjectName" label="科目名称" width="100"></el-table-column>

        <el-table-column prop="title" label="课程名称"></el-table-column>

        <el-table-column prop="curriculum_desc" label="课程介绍" :show-overflow-tooltip="true"></el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="bulkAddCurriculumAuth">确认授权</el-button>
        <el-button size="small" @click="quitDialog('form')">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑课程权限" :visible.sync="dialogVisible1" width="400px">
      <el-form class="form-style" ref="form" :model="form" :rules="rules" label-width="100px" label-position="left" size="small">
        <el-form-item label="课程节数:" required prop="course_authority">
          <el-input-number v-model="form.course_authority" :precision="0"></el-input-number>

          <span style="margin-left: 10px">共{{ form.current_curriculum_num }}节</span>
        </el-form-item>

        <el-form-item label="可分配数:" required prop="max_teacher_num">
          <el-input-number v-model="form.max_teacher_num" :precision="0"></el-input-number>
        </el-form-item>
        <el-form-item label="截止日期:" required prop="off_time">
          <!-- <el-date-picker v-model="form.off_time" type="date" placeholder="请选择系统截止日期"
            value-format="yyyy-MM-dd"></el-date-picker> -->
          <el-date-picker v-model="form.off_time" default-time="23:59:59" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择系统截止日期" placement="bottom-start">
          </el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submit('form')">确 定</el-button>
        <el-button size="small" @click="dialogVisible1 = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批量修改时间" :visible.sync="dialogVisible2" width="400px">
      <el-form class="form-style" ref="form" :model="form" :rules="rules" label-width="100px" label-position="left" size="small">
        <el-form-item label="截止日期:" required>
          <!-- <el-date-picker v-model="curriculum_offtime" type="date" placeholder="请选择系统截止日期"
            value-format="yyyy-MM-dd"></el-date-picker> -->
          <el-date-picker v-model="curriculum_offtime" default-time="23:59:59" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择系统截止日期" placement="bottom-start">
          </el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="bulkUpdateCurriculumAuth">确 定</el-button>
        <el-button size="small" @click="dialogVisible1 = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCurriculumPermissions,
  deleteCurriculumPermissions,
  updateAdminCurriculumForEducationalInstitution,
  getEducationalInstitutionList,
  getPrincipalUserList,
  getSubjectList,
  adminGetSchoolSubjectList,
  bulkAddCurriculumAuth,
  bulkUpdateCurriculumAuth,
  bulkDeleteCurrOfSchool
} from '@/api/admin'
import { getCurriculumList } from '@/api/educational'
export default {
  name: 'school-system-permissions',
  data() {
    return {
      off_time_state: '2',
      options: [
        {
          id: '',
          name: '全部',
        },
        {
          id: '1',
          name: '已到期',
        },
        {
          id: '2',
          name: '未到期',
        },
      ],
      curriculum_list: [],
      subjectPermissionId: '',
      loading: false,
      educational_institution_list: [],
      ruleForm: {
        educational_institution_id: '',
        user_id: '',
      },
      page_no: 1,
      total: 0,
      pageSize: 200,

      page_no1: 1,

      tableData: [],
      principalUserList: [],
      subjectList: [],
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      form: {
        curriculum_id: '',
        educational_institution_id: '',
        max_teacher_num: 5,
        course_authority: '',
        subject_id: '',
        off_time: '',
        current_curriculum_num: 0,
        teaching_type: '1',
        curriculum_type: '',
        is_try: '0',
        is_effective: '1',
      },
      rules: {
        educational_institution_id: [
          {
            required: true,
            message: '请选择学校',
            trigger: 'change',
          },
          {
            required: true,
            message: '请选择学校',
            trigger: 'blur',
          },
        ],
        subject_id: [
          {
            required: true,
            message: '请选择科目',
            trigger: 'change',
          },
          {
            required: true,
            message: '请选择科目',
            trigger: 'blur',
          },
        ],
        curriculum_id: [
          {
            required: true,
            message: '请选择课程',
            trigger: 'change',
          },
          {
            required: true,
            message: '请选择课程',
            trigger: 'blur',
          },
        ],
        course_authority: [
          {
            required: true,
            message: '请输入课程权限',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入课程权限',
            trigger: 'blur',
          },
        ],
        off_time: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change',
          },
          {
            required: true,
            message: '请选择时间',
            trigger: 'blur',
          },
        ],
      },
      subjectList_platform: [],
      curriculumlist: [], //已选课程
      edit_curriculumlist: [], //批量修改到期时间
      curriculum_offtime: '', //到期时间
    }
  },
  computed: {},
  mounted() {
    if (!this.$route.query.id) {
      this.$message.warning('请选择校区')
      this.$router.push({
        name: 'cooperative-school',
      })
      return
    }

    this.getCurriculumPermissions() //体系权限列表
    this.adminGetSchoolSubjectList()
  },

  watch: {
    'form.curriculum_id': {
      handler: function () {
        //do something
        console.log('课程体系发生变化')

        for (let k = 0; k < this.curriculum_list.length; k++) {
          if (this.form.curriculum_id == this.curriculum_list[k].id) {
            this.form.current_curriculum_num = this.curriculum_list[
              k
            ].number_of_courses
            this.form.course_authority = this.curriculum_list[
              k
            ].number_of_courses
          }
        }
      },
      deep: true,
    },

    'form.subject_id': {
      handler: function () {
        for (let k = 0; k < this.subjectList.length; k++) {
          if (this.form.subject_id == this.subjectList[k].subjectInfo.id) {
            this.form.off_time = this.subjectList[k].off_time
          }
        }
      },
      deep: true,
    },
  },

  methods: {
    // 获取课程体系
    getCurriculumList(status) {
      if (status === 'change') {
        this.form.curriculum_id = ''
      }
      getCurriculumList(
        {
          is_effective: this.form.is_effective,
          is_try: this.form.is_try,
          subject_id: this.form.subject_id,
          teaching_type: this.form.teaching_type,
          curriculum_type: this.form.curriculum_type,
          page_size: 200,
        },
        true
      ).then((res) => {
        console.log('查询课程体系')
        console.log(res)

        this.curriculum_list = res.curriculum_list
        //this.form.current_curriculum_num
      })
    },
    getSubjectList() {
      getSubjectList({ subject_state: 1, page_size: 200 }, true).then((res) => {
        console.log('平台科目')
        console.log(res)

        this.subjectList_platform = res.subject_list
      })
    },
    // 获取校长账号列表
    getPrincipalUserList() {
      this.loading = true
      getPrincipalUserList({
        page_size: 200,
      }).then((res) => {
        this.principalUserList = res.principal_user_list
        this.loading = false
      })
    },
    // 获取合作学校列表
    getEducationalInstitutionList(query) {
      this.loading = true
      getEducationalInstitutionList({
        educational_institution_name: query,
        page_size: 200,
      }).then((res) => {
        this.educational_institution_list = res.educational_institution_list
        this.loading = false
      })
    },

    //获得校区已有的科目权限

    adminGetSchoolSubjectList() {
      if (!this.$route.query.id) {
        return
      }

      return adminGetSchoolSubjectList({
        schoolId: this.$route.query.id,
      }).then((res) => {
        console.log('查询校区已有科目')
        console.log(res)
        this.subjectList = res.schoolSubjectAuthList
        if (res.schoolSubjectAuthList.join('') !== '')
          this.form.subject_id = res.schoolSubjectAuthList[0].subject_id
      })
    },

    async addSubjectPermission() {
      this.form.off_time = this.$route.query.off_time
      this.dialogVisible = true

      this.subjectPermissionId = ''
      this.form.educational_institution_id = this.ruleForm.educational_institution_id
      // this.form.max_teacher_num = 1;
      this.form.subject_id = ''
      this.form.curriculum_id = ''
      this.form.course_authority = ''
      // this.form.off_time = "";
      await this.adminGetSchoolSubjectList()
      this.getCurriculumList()
    },

    //批量修改时间
    bulkUpdate() {
      if (this.edit_curriculumlist.length == 0) {
        this.$message.warning('请选择课程')
        return
      }
      this.curriculum_offtime = this.$route.query.off_time
      this.dialogVisible2 = true
    },
    // 批量删除
    bulkDelete() {
      if (this.edit_curriculumlist.length === 0) {
        return this.$message.warning('请选择课程')
      }
      const ids = []
      this.edit_curriculumlist.forEach(item => {
        ids.push(item.id)
      })
      this.$confirm('是否确认删除选中的课程', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await bulkDeleteCurrOfSchool({ currPerIdArr: JSON.stringify(ids) });
        if (res && res.is_delete) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        } else {
          this.$message({
            type: 'error',
            message: '删除失败'
          });
        }
        this.getCurriculumPermissions()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //批量修改课程到期时间
    bulkUpdateCurriculumAuth() {
      if (!this.curriculum_offtime) {
        this.$message.warning('请选择到期时间')
        return
      }

      var curriculumAuthIds = []
      for (let k = 0; k < this.edit_curriculumlist.length; k++) {
        curriculumAuthIds.push(this.edit_curriculumlist[k].id)
      }

      bulkUpdateCurriculumAuth({
        curriculumAuthIds: JSON.stringify(curriculumAuthIds),
        off_time: this.curriculum_offtime,
      }).then((res) => {
        console.log('批量调整上课时间')
        console.log(res)
        if (res.is_update) {
          this.$message.success('修改成功')
          this.getCurriculumPermissions()
          this.dialogVisible2 = false
        }
      })
    },

    quitDialog(formName) {
      this.$refs[formName].resetFields()
      this.dialogVisible = false
    },
    updateSubjectPermission(row) {
      console.log('更新校区体系权限')
      console.log(row)

      this.subjectPermissionId = row.id
      this.form.educational_institution_id = row.educational_institution_id
      this.form.max_teacher_num = row.max_teacher_num
      this.form.subject_id = row.subject_id
      this.form.curriculum_id = row.curriculum_id
      this.form.course_authority = row.course_authority
      this.form.off_time = row.off_time

      this.adminGetSchoolSubjectList() //校区科目权限
      this.getCurriculumPermissions()
      this.getCurriculumList()

      this.dialogVisible1 = true
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.subjectPermissionId) {
            console.log('编辑课程体系权限参数')
            console.log(this.form.educational_institution_id)
            console.log(this.subjectPermissionId)
            console.log(this.form.curriculum_id)
            console.log(this.form.course_authority)
            console.log(this.form.max_teacher_num)
            console.log(this.form.off_time)

            updateAdminCurriculumForEducationalInstitution({
              educational_institution_id: this.$route.query.id,
              curriculum_promission_id: this.subjectPermissionId,
              curriculum_id: this.form.curriculum_id,
              course_authority: this.form.course_authority,
              max_teacher_num: this.form.max_teacher_num,
              off_time: this.form.off_time,
            }).then(() => {
              this.$message.success('修改权限成功！')
              this.dialogVisible1 = false
              this.getCurriculumPermissions()
            })
          }
        }
      })
    },
    deleteSubjectPermission(row) {
      this.$confirm('确定删除当前课程权限?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteCurriculumPermissions({
          curriculum_promission_id: row.id,
        }).then(() => {
          this.$message.success('删除成功！')
          this.getCurriculumPermissions()
        })
      })
    },
    search() {
      this.page_no = 1
      this.getCurriculumPermissions()
    },

    search1() {
      this.page_no1 = 1
      this.getCurriculumPermissions()
    },
    handleSizeChange2(val) {
      this.pageSize = val
      this.getCurriculumPermissions()
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getCurriculumPermissions()
    },
    getCurriculumPermissions() {
      if (!this.$route.query.id) {
        this.$message.warning('请选择校区')
        return
      }

      getCurriculumPermissions({
        off_time_state: this.off_time_state,
        educational_institution_id: this.$route.query.id,
        subject_id: this.ruleForm.subject_id,
        user_id: '',
        page_size: this.pageSize,
        page_no: this.page_no,
      }).then((res) => {
        console.log('课程体系权限列表')
        console.log(res)
        this.tableData = res.curriculum_permssion_list
        this.total = res.total
      })
    },

    //批量添加校区课程权限
    bulkAddCurriculumAuth() {
      if (this.curriculumlist.length == 0) {
        this.$message.warning('请选择课程')
        return
      }

      if (!this.form.off_time) {
        this.$message.warning('请选择截止日期')
        return
      }

      var curriculumAuthArr = []
      var curriculum = {
        curriculum_id: '',
        course_authority: 0,
        max_teacher_num: 0,
        off_time: '',
      }

      for (let k = 0; k < this.curriculumlist.length; k++) {
        curriculum = {
          currId: this.curriculumlist[k].id,
          offTime: this.form.off_time,
          subjectId: this.curriculum_list[k].subject_id
        }
        curriculumAuthArr.push(curriculum)
      }

      console.log('提交的参数')
      console.log(curriculumAuthArr)

      bulkAddCurriculumAuth({
        eduId: this.$route.query.id,
        list: curriculumAuthArr,
      }).then((res) => {
        console.log('批量添加校区课程权限')
        console.log(res)
        if (res) {
          this.$notify({
            title: '警告:',
            message: res.split('\n').join('<br/>'),
            type: 'warning',
            dangerouslyUseHTMLString: true,
            duration: 2000,
          })
        } else {
          this.dialogVisible = false
          this.$message.success('授权成功')

        }
        this.getCurriculumPermissions()
      })
    },

    handleSelectionChange(val) {
      console.log('已选课程')
      console.log(val)
      this.curriculumlist = val
    },

    //批量修改到期时间
    handleSelectionChange1(val) {
      console.log('批量修改到期时间')
      console.log(val)
      this.edit_curriculumlist = val
    },

    AddData() {
      console.log('添加流量')
      this.$router.push({
        name: 'data-management',
        query: {
          id: this.$route.query.id,
          off_time: this.$route.query.off_time,
          domain: this.$route.query.domain,
          name: this.$route.query.name,
        },
      })
    },
  },
}
</script>

<style scoped lang="scss">
.school-system-permissions {
  min-height: 100%;
  background-color: #fff;
  padding-top: 5px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 15px;
  margin: 10px;
  border-radius: 5px;

  .form-style {
  }

  .table-style {
  }
}
</style>
